module.exports = __webpack_public_path__ + "static/VeneerCleanRound-d3dd4864fc63b8e7295fe47e85d0d5ef.woff";